// extracted by mini-css-extract-plugin
export var headerCell = "_16-1";
export var loadingStateCell = "_16-4";
export var rowWrapper = "_16-3";
export var standaloneTable = "_16-5";
export var table = "_16-0";
export var white = "_16-2";